<template>
  <div class="pc-bd">
    <div class="pc-inset" v-if="isPCShow">
      <div class="page-show-box">
        <div
          class="page-btn"
          v-for="(n, index) in modules"
          :key="index"
          :class="index === pageIndex ? 'selected' : null"
        ></div>
      </div>
      <main-box
        ref="mainBox"
        :pageindex="pageIndex"
        v-on:changeP="pageCh($event)"
      />
      <function-introduction ref="functionIntroduction" />
      <im-introduction ref="imIntroduction" />
      <payment-introduction ref="paymentIntroduction" />
      <app-download ref="appDownload" />
      <about-us ref="aboutUs" />
    </div>
    <div class="menu">
      <div class="menu-left">
        <div
          class="menu-list1"
          :class="pageIndex === index ? 'activated' : ''"
          v-for="(item, index) in menuList"
          @click="changeIndex(index)"
          :key="index"
        >
          <template v-if="item">
            <p v-if="index != 2">{{ item.title }}</p>
            <img
              :src="logo"
              alt=""
              class="logo"
              @click="change"
              v-if="index == 2"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mainCss from "../css/main.css";
import mainBox from "./modules/main-box";
import appDownload from "./modules/app-download";
import functionIntroduction from "./modules/function-introduction";
import paymentIntroduction from "./modules/payment-introduction";
import imIntroduction from "./modules/im-introduction";
import aboutUs from "./modules/about-us";
import { logo } from "../images/menu/index";
export default {
  data() {
    return {
      pageIndex: 0,
      modules: [
        "mainBox",
        "functionIntroduction",
        "imIntroduction",
        "paymentIntroduction",
        "appDownload",
        "aboutUs"
      ],
      logo,
      stopper: false,
      isPCShow: true,
      menuList: [
        {
          title: "ホーム"
        },
        {
          title: "機能"
        },
        {
          title: logo
        },
        null,
        {
          title: "ダウンロード"
        },
        {
          title: "お問い合わせ"
        }
      ]
    };
  },
  components: {
    mainBox,
    appDownload,
    functionIntroduction,
    paymentIntroduction,
    imIntroduction,
    aboutUs
  },
  created() {
    this.$nextTick(() => {
      // this.$refs.shareBox.init(this.init())
      this.init();
    });
  },
  watch: {
    pageIndex(n, o) {
      if (n > o) {
        this.$refs["functionIntroduction"].die();
        this.$refs[this.modules[o]].up();
        this.$refs[this.modules[n]].nomal();
      } else if (o > n) {
        this.$refs["functionIntroduction"].die();
        this.$refs[this.modules[o]].down();
        this.$refs[this.modules[n]].nomal();
      }
    }
  },
  methods: {
    init() {
      if (
        /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) ||
        /(Android)/i.test(navigator.userAgent) ||
        navigator.userAgent.indexOf("Linux") > -1
      ) {
        this.$router.push("/pe");
      } else {
        this.isPCShow = true;
        this.$refs.mainBox.init();
        this.windowAddMouseWheel();
      }
    },
    pageCh(msg) {
      this.pageIndex = msg;
    },
    isPC() {
      let userAgentInfo = navigator.userAgent;
      let Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
      );
      let flag = true;
      for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    changeIndex(index) {
      console.log("index =>", index);
      if (index === 6) {
        this.$router.push("/merchantsEntering");
        return false;
      }
      if (index == 2) {
        return false;
      }
      this.pageIndex = index;
    },
    change() {
      this.pageIndex = 0;
    },
    windowAddMouseWheel() {
      let _self = this;
      var scrollFunc = function(e) {
        if (!this.stopper) {
          e = e || window.event;
          if (e.wheelDelta) {
            //判断浏览器IE，谷歌滑轮事件
            if (e.wheelDelta > 0) {
              //当滑轮向上滚动时
              _self.pageIndex -= 1;
              if (_self.pageIndex < 0) {
                _self.pageIndex = 0;
              }
              _self.isMenuShow = false;

              _self.$refs[_self.modules[_self.pageIndex]].nomal();
              _self.$refs[_self.modules[_self.pageIndex + 1]].down();
            }
            if (e.wheelDelta < 0) {
              //当滑轮向下滚动时
              _self.pageIndex += 1;
              if (_self.pageIndex >= _self.modules.length) {
                _self.pageIndex = _self.modules.length - 1;
              }
              _self.isMenuShow = false;
              _self.$refs[_self.modules[_self.pageIndex - 1]].up();
              _self.$refs[_self.modules[_self.pageIndex]].nomal();
            }
          } else if (e.detail) {
            //Firefox滑轮事件
            if (e.detail > 0) {
              //当滑轮向上滚动时
              _self.pageIndex -= 1;
              if (_self.pageIndex < 0) {
                _self.pageIndex = 0;
              }
              _self.isMenuShow = false;
              _self.$refs[_self.modules[_self.pageIndex]].nomal();
              _self.$refs[_self.modules[_self.pageIndex]].down();
            }
            if (e.detail < 0) {
              //当滑轮向下滚动时
              _self.pageIndex += 1;
              if (_self.pageIndex >= _self.modules.length) {
                _self.pageIndex = _self.modules.length - 1;
              }
              _self.isMenuShow = false;
              _self.$refs[_self.modules[_self.pageIndex - 1]].up();
              _self.$refs[_self.modules[_self.pageIndex]].nomal();
            }
          }
        }
        if (this.stopper === true) {
        } else {
          this.stopper = true;
          setTimeout(() => {
            this.stopper = false;
          }, 500);
        }
      };
      document.onmousewheel = scrollFunc;
    }
  }
};
</script>
<style scoped>
.pc-bd {
  width: 100%;
  height: 100%;
  position: relative;
}
.pc-title-area {
  width: 100%;
  position: fixed;
  top: 0;
  background: rgba(255, 255, 255, 0.4);
  height: 0.5rem;
  z-index: 999;
  line-height: 0.5rem;
  color: #fff;
  transition: all 0.5s;
  overflow: hidden;
  text-align: center;
}
.page-show-box {
  position: absolute;
  right: 0.1rem;
  width: 0.3rem;
  height: 0.5rem;
  bottom: 0;
  top: 0.5rem;
  z-index: 999;
  margin: auto;
}
.page-btn {
  width: 0.05rem;
  height: 0.05rem;
  margin: 0.05rem 0.11rem;
  border-radius: 50%;
  background: #bbbbbb;
}
.page-btn.selected {
  background: #e8c921;
}
.logo {
  position: absolute;
  left: 50%;
  margin-left: -1rem;
  text-align: center;
  top: 0;
  width: 1.5rem;
  height: auto;
  margin-top: 0.15rem;
}
.navbar-menu-icon {
  font-size: 0.2rem;
  margin-right: 0.05rem;
}
.menu-list {
  font-size: 0.2rem;
  width: 2rem;
  height: 1rem;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.menu-list1 {
  width: 2rem;
  height: 0.6rem;
  font-size: 0.2rem;
  line-height: 0.6rem;
  text-align: center;
  color: #fff;
  cursor: pointer;
}
.menu-list.activated {
  color: #dbbf2a;
}
.menu-list1.activated {
  color: #dbbf2a;
}
.menu-icon {
  transform: rotate(0deg);
  transition: all 0.5s;
  color: rgba(208, 208, 208, 1);
}
.menu {
  width: 100%;
  height: 0.6rem;
  line-height: 0.6rem;
  transition: all 0.5s;
  font-weight: bold;
  background-color: #333333;
  position: fixed;
  display: flex;
  justify-content: space-around;
  top: 0;
  z-index: 900;
}
.menu-left {
  display: flex;
  justify-content: space-around;
}
.pc-inset {
  width: 100%;
  height: 100%;
  position: relative;
  transition: all 0.5s;
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue